// Tier-based theme colors for the player app
// Iter 137: replaced Ruby/Pearl with Elite/Legend; added richer accents.
export const TIER_THEMES = {
  Bronze: {
    primary: '#CD7F32', secondary: '#8B5E3C', accent: '#F5D76E',
    glow: 'rgba(205,127,50,0.45)',
    bg: 'linear-gradient(180deg, #2a1a0e 0%, #0d1117 40%, #0a0e17 100%)',
    headerBg: 'rgba(42,26,14,0.92)', headerBorder: 'rgba(205,127,50,0.2)',
    navBg: 'rgba(42,26,14,0.95)', navBorder: 'rgba(205,127,50,0.15)',
    balanceBg: 'linear-gradient(135deg, rgba(205,127,50,0.15), rgba(205,127,50,0.05))',
    balanceBorder: '1px solid rgba(205,127,50,0.3)',
  },
  Silver: {
    primary: '#C0C0C0', secondary: '#808080', accent: '#E8E8E8',
    glow: 'rgba(192,192,192,0.45)',
    bg: 'linear-gradient(180deg, #1a1a2e 0%, #0d1117 40%, #0a0e17 100%)',
    headerBg: 'rgba(26,26,46,0.92)', headerBorder: 'rgba(192,192,192,0.2)',
    navBg: 'rgba(26,26,46,0.95)', navBorder: 'rgba(192,192,192,0.15)',
    balanceBg: 'linear-gradient(135deg, rgba(192,192,192,0.15), rgba(192,192,192,0.05))',
    balanceBorder: '1px solid rgba(192,192,192,0.3)',
  },
  Gold: {
    primary: '#D4AF37', secondary: '#B8860B', accent: '#F5D76E',
    glow: 'rgba(212,175,55,0.55)',
    bg: 'linear-gradient(180deg, #1a0a2e 0%, #0d1117 40%, #0a0e17 100%)',
    headerBg: 'rgba(15,10,30,0.92)', headerBorder: 'rgba(212,175,55,0.2)',
    navBg: 'rgba(15,10,30,0.95)', navBorder: 'rgba(212,175,55,0.15)',
    balanceBg: 'linear-gradient(135deg, rgba(212,175,55,0.15), rgba(212,175,55,0.05))',
    balanceBorder: '1px solid rgba(212,175,55,0.3)',
  },
  Platinum: {
    primary: '#E5E4E2', secondary: '#B0B0B0', accent: '#F0F0F0',
    glow: 'rgba(229,228,226,0.5)',
    bg: 'linear-gradient(180deg, #1e1e2e 0%, #12121a 40%, #0a0e17 100%)',
    headerBg: 'rgba(30,30,46,0.92)', headerBorder: 'rgba(229,228,226,0.2)',
    navBg: 'rgba(30,30,46,0.95)', navBorder: 'rgba(229,228,226,0.15)',
    balanceBg: 'linear-gradient(135deg, rgba(229,228,226,0.12), rgba(229,228,226,0.04))',
    balanceBorder: '1px solid rgba(229,228,226,0.25)',
  },
  Diamond: {
    primary: '#B9F2FF', secondary: '#4FC3F7', accent: '#E0F7FA',
    glow: 'rgba(185,242,255,0.6)',
    bg: 'linear-gradient(180deg, #0a1a2e 0%, #0d1117 40%, #0a0e17 100%)',
    headerBg: 'rgba(10,26,46,0.92)', headerBorder: 'rgba(185,242,255,0.2)',
    navBg: 'rgba(10,26,46,0.95)', navBorder: 'rgba(185,242,255,0.15)',
    balanceBg: 'linear-gradient(135deg, rgba(185,242,255,0.12), rgba(185,242,255,0.04))',
    balanceBorder: '1px solid rgba(185,242,255,0.25)',
  },
  Elite: {
    // Black with gold accents — premium, intimidating, made for whales.
    primary: '#FFD700', secondary: '#0a0a0a', accent: '#F5D76E',
    glow: 'rgba(255,215,0,0.7)',
    bg: 'linear-gradient(180deg, #0a0a0a 0%, #050505 40%, #000 100%)',
    headerBg: 'rgba(8,8,8,0.96)', headerBorder: 'rgba(255,215,0,0.35)',
    navBg: 'rgba(5,5,5,0.97)', navBorder: 'rgba(255,215,0,0.25)',
    balanceBg: 'linear-gradient(135deg, rgba(255,215,0,0.18), rgba(255,215,0,0.04))',
    balanceBorder: '1px solid rgba(255,215,0,0.4)',
  },
  Legend: {
    // Royal purple + gold — the apex aesthetic; used only for top players.
    primary: '#FFD700', secondary: '#9d4edd', accent: '#E0AAFF',
    glow: 'rgba(157,78,221,0.7)',
    bg: 'linear-gradient(180deg, #1a0a2e 0%, #0e0420 40%, #050010 100%)',
    headerBg: 'rgba(20,8,42,0.94)', headerBorder: 'rgba(255,215,0,0.4)',
    navBg: 'rgba(14,4,32,0.95)', navBorder: 'rgba(255,215,0,0.3)',
    balanceBg: 'linear-gradient(135deg, rgba(255,215,0,0.18), rgba(157,78,221,0.08))',
    balanceBorder: '1px solid rgba(255,215,0,0.4)',
  },
};

// Backward-compat aliases — older user records may still carry "Ruby"/"Pearl"
// labels until their next tier recalculation. Map them to the new themes so
// the UI never crashes.
TIER_THEMES.Ruby = TIER_THEMES.Elite;
TIER_THEMES.Pearl = TIER_THEMES.Legend;

export function getTierTheme(tierName) {
  return TIER_THEMES[tierName] || TIER_THEMES.Bronze;
}
